import { ModelBase } from '../shared/model.base';

export class ShortCodeCompany extends ModelBase {
  organization_id: number;
  operator_id: number;
  short_code_id: number;
  esm_class: 0;
  register_delivery: 0;
  service_type: 0;
  description: '';

  constructor() {
    super();
  }
}
